<script setup lang="ts">
import type { Component, HTMLAttributes } from 'vue'
import { computed } from 'vue'
import { Primitive } from 'reka-ui'
import { cn } from '@ds/lib/utils'

type Props = {
  icon?: Component
  label: string
  active?: boolean
  /** Set `as="div"` (default) for inert rows in menus, or `as="RouterLink"` (+ `to`) for navigable rows in inline lists. */
  as?: string | Component
  class?: HTMLAttributes['class']
  dataHandle?: boolean
  isMobile?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  active: false,
  as: 'div',
})

defineOptions({
  inheritAttrs: false,
})

const rowClasses = computed(() => cn(
  'flex min-w-0 items-center gap-2.5 rounded-ds-sm px-2.5 text-sm font-medium',
  'transition-colors duration-ds-fast ease-ds-standard',
  props.isMobile ? 'h-11' : 'h-9',
  props.class,
))
</script>

<template>
  <Primitive
    :as="as"
    :class="rowClasses"
    v-bind="$attrs"
  >
    <component
      :is="icon"
      v-if="icon"
      class="size-4 shrink-0"
      :class="dataHandle ? 'opacity-50 hover:opacity-100 cursor-move' : undefined"
      aria-hidden="true"
      :data-handle
    />
    <slot name="label">
      <span class="min-w-0 flex-1 truncate text-left">{{ label }}</span>
    </slot>
    <slot name="trailing" />
  </Primitive>
</template>
